module.exports = __webpack_public_path__ + "img/main-header.4d4e29c0.jpg";